import http from "../http-common";

const storeUser = userData => {
    const user = {...userData};
    delete user.refreshToken;
    localStorage.setItem("user", JSON.stringify(user));
    return user;
};

class PublicService {
  login(login, password) {
    return http
      .post("/api/public/login", { login, password })
      .then(response => {
        if (response.data.requiresTwoFactor) {
          return response.data;
        }

        if (response.data.token) {
            storeUser(response.data);
        }

        return response.data;
      });
  }

  verifyTwoFactor(twoFactorToken, code) {
    return http
      .post("/api/public/login/verify-2fa", { twoFactorToken, code })
      .then(response => {
        if (response.data.token) {
            storeUser(response.data);
        }

        return response.data;
      });
  }

  logout() {
      const user = this.getCurrentUser();
    localStorage.removeItem("user");
      if (user && user.token) {
          http.post("/api/public/login/logout", {}, {
              headers: {Authorization: user.token}
          }).catch(() => {
          });
    }
  }

  getCurrentUser() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && Object.prototype.hasOwnProperty.call(user, "refreshToken")) {
          return storeUser(user);
      }
      return user;
  }

    forgotPassword(email) {
        return http.post("/api/public/password/forgot", {email});
    }

    resetPassword(token, newPassword) {
        return http.post("/api/public/password/reset", {token, newPassword});
    }
}

export default new PublicService();
